<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="650px"
  >
    <v-card
    >
      <v-card-title>
        <span v-if="editCreate" class="text-h5">Verknüpfung erstellen</span>
        <span v-else class="text-h5">Verknüpfung bearbeiten</span>
      </v-card-title>
      <v-card-text
        v-if="editMachine !== null"
      >
        <v-container
          fluid
        >
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editMachine.displayName"
                label="Bezeichnung"
                required
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-combobox
                v-model="editMachine.kategory"
                :items="location_keys"
                dense
                hide-details
              ></v-combobox>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="editMachine.tags"
                label="Tags"
                hint="Tags müssen durch Semikolon getrennt werden"
                persistent-hint
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="editMachine.description"
                label="Kurzbeschreibung"

                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="editMachine.host"
                label="IP/Host"
                hint="IP-Adresse der Maschine"
                persistent-hint
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="editMachine.mac"
                label="MAC"
                hint="MAC-Adresse der Maschine"
                persistent-hint
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="editMachine.proxy_link"
                label="Wake-on-lan/isAlive Proxy"
                hint="Link des Satteliten, um wol durchzuführen und den Status zu überwachen"
                persistent-hint
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="8"
              sm="10"
            >
              <v-text-field
                v-model="editMachine.vnc_ip"
                label="IP-Adresse des VNC-Proxy"
                hide-details
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="4"
              sm="2"
            >
              <v-text-field
                v-model="editMachine.vnc_port"
                label="Port"
                hide-details
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editMachine.password"
                label="Password"
                type="password"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="delete_machine"
        >
          Löschen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="close_dialog"
        >
          Schließen
        </v-btn>
        <v-btn
          color="success darken-1"
          text
          @click="(editCreate) ? create_machine() : save_machine()"
        >
          {{ (editCreate) ? 'Erstellen' : 'Speichern' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "mv-edit-frame",
  props: ['editMachine', 'editCreate'],
  computed: {
    dialog(){
      return this.editMachine !== null
    },
    location_keys(){
      let location_keys = []
      for(let index in this.$store.state.machine_viewer.locations){
        let location = this.$store.state.machine_viewer.locations[index]
        if(!(location["kategory"] in location_keys)) {
          location_keys.push(location["kategory"])
        }
      }
      return location_keys
    }
  },
  data: () => ({
    //machine: { ...this.editMachine }
  }),
  methods: {
    delete_machine(){
      this.$store.dispatch("update", { "payload_type": "DELETE", "context": "/vnc/" + this.editMachine.id })
      this.close_dialog()
    },
    close_dialog(){
      this.$emit('closeDialog')
      //this.$parent.data.editMachine = null
      //this.$parent.closeEdit()
    },
    create_machine(){
      this.$store.dispatch("update", { "payload_type": "POST", "context": "/vnc", 'payload': this.editMachine })
      this.close_dialog()
    },
    save_machine(){
      this.$store.dispatch("update", { "payload_type": "PUT", "context": "/vnc/" + this.editMachine.id, 'payload': this.editMachine })
      this.close_dialog()
    }
  }
};
</script>

<style scoped>

</style>
